<template>
    <div>
        <div v-if="informationvenuescomponent" style="margin-top:25px">
            <v-flex>
                <v-card color="#11679A" class="white--text">
                    <div class="text-xs-center hidden-lg-only hidden-xl-only">
                        <v-btn @click="opencomponentvenues">Ver sedes</v-btn>
                        <v-btn @click="showcomponentedit">Editar</v-btn>
                        <!--<v-btn v-if="sede[0].isvenueprincipal === false" @click="openmodalservicesbyvenues">Servicios</v-btn>-->
                        <v-btn>Eliminar sede</v-btn>
                    </div>
                    <v-layout class="hidden-sm-and-down hidden-md-and-down">
                        <v-flex xs12>
                            <v-layout v-if="locationvenues!=undefined" justify-center style="margin-top:2px">
                                <div :style="'height:320px;position:relative; z-index:1; width:90%'">
                                    <l-map :zoom=15 :center="[locationvenues[0], locationvenues[1]]">
                                        <l-tile-layer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                                        <l-circle-marker :lat-lng="[locationvenues[0], locationvenues[1]]" fillColor="#07e8f4" color="#fff" :fillOpacity="1">
                                            <l-popup>
                                                <label>{{sede[0].name}}</label>
                                            </l-popup>
                                        </l-circle-marker>
                                    </l-map>
                                </div>
                            </v-layout>
                            <div class="text-xs-center hidden-sm-and-down hidden-md-and-down">
                                <v-btn @click="opencomponentvenues">Ver sedes</v-btn>
                                <v-btn @click="showcomponentedit();gobackseevenues()">Editar</v-btn>
                                <!--<v-btn v-if="sede[0].isvenueprincipal === false" @click="openmodalservicesbyvenues">Servicios</v-btn>-->
                                <v-btn v-if="sede[0].isvenueprincipal === false" @click="modaldelete = true">Eliminar sede</v-btn>
                            </div>
                        </v-flex>
                        <v-flex xs12>
                            <v-card-title primary-title>
                                <div>
                                <div class="headline">{{sede[0].name}}</div>
                                <div>{{sede[0].address}}</div>
                                </div>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                    <v-divider light></v-divider>
                    
                </v-card>
            </v-flex>
        </div>
        <div v-if="ModalCreactionVenues" style="margin-top:30px">
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="createcompanyvenues">
                <v-layout>   
                    <v-layout column>
                        <v-layout justify-center>
                            <label style="font-size:20px; font-weight:bold;">{{isEdit === true && sede.length > 0 ? 'Editar ' + sede[0].name: 'Creación de Sedes'}}</label>
                        </v-layout>
                        <v-layout column>
                            <v-layout style="margin:1px" class="text-xs-center" >
                                <v-flex >
                                    <v-text-field :rules="[rules.required]" required placeholder="Escriba el nombre de la sede" outline v-model="createvenues.name"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-chip
                                class="ma-2"
                                outlined
                            >
                                <v-icon style="margin-left:5px;font-size:15px">fas fa-info</v-icon>
                                <p style="margin-left:5px">{{isaddresscorrect === false ? 'Escriba la dirección referencial de su empresa.' : 'Elija el punto exacto de su empresa'}}</p>
                            </v-chip>
                            
                            <v-layout justify-center>
                                <div :style="'height:320px;position:relative; z-index:1; width:90%'"  @click="writeaddress" @keyup="writeaddress">
                                    <l-map :zoom=13 :center="[latitude, longitude]" @click="addMarker">
                                        <v-geosearch :options="geosearchOptions"></v-geosearch>
                                        <l-tile-layer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                                    
                                        <l-marker v-for="(marker,index) in markers"  :key="index+1" :lat-lng="marker" ></l-marker>
                                        <l-circle-marker v-for="locationvenues in locationvenues"  :key="locationvenues.length"  :lat-lng="[locationvenues.latitude, locationvenues.longitude]" fillColor="#07e8f4" color="#fff" :fillOpacity="1">
                                            <l-popup v-if="isEdit === true">
                                                <label>{{sede[0].name}}</label>
                                            </l-popup>
                                        </l-circle-marker>
                                    </l-map>
                                </div>
                            </v-layout>
                            <v-btn v-if="isaddresscorrect === false" @click="functionaddressiscorrect">Dirección referencial correcta</v-btn>
                            
                            <v-layout style="margin:4px" align-center class="text-xs-center">
                                <v-flex  >
                                    <v-text-field v-model="createvenues.address" :rules="[rules.required]" required :disabled="disabledinputaddress === true && isaddresscorrect === false && isEdit===false" @keyup="writeinputaddress"  placeholder="Escriba la direccion de la sede" outline></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                        <!--cargar imagen-->
                        <!--
                        <v-layout justify-center>
                            <v-flex xs10 md6>
                                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                                    <img :src="imageUrl" height="120" v-if="imageUrl"/>
                                    <v-text-field label="Seleccionar Imagen" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
                                    <input
                                        type="file"
                                        style="display: none"
                                        ref="image"
                                        accept="image/*"
                                        @change="onFilePicked"
                                    >
                                </v-flex>
                            </v-flex>
                        </v-layout>-->
                        <!--Fin cargar imagen-->
                        
        
                            
                            

                        <v-layout justify-center>
                            <v-btn color="#11679a" type="submit" :disabled="!valid || isaddresscorrect===false && isEdit === false" style="color:white">{{isEdit === true ? 'EDITAR SEDE' : 'CREAR SEDE'}}</v-btn>
                        </v-layout>
                        <v-layout justify-center v-if="isEdit ===false">
                            <v-btn color="#11679a" type="button" style="color:white" @click="opencomponentvenues();gobackseevenues()">VER SEDES</v-btn>
                        </v-layout>
                        <v-layout justify-center v-if="isEdit ===true">
                            <v-btn color="#11679a" type="button" style="color:white" @click="ModalCreactionVenues = false; informationvenuescomponent = true; gobackseevenues()">VOLVER</v-btn>
                        </v-layout>
                    </v-layout>
                </v-layout>
            </v-form>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../../helpers/eventbus/event-bus'
import initVue from '../../../helpers/initVue.js';
import env from '../../../config/env.example'

//import Maps from './Maps'
const alertify = require('alertifyjs')

import Venues from '../../../models/createvenues'
import { LMap, LTileLayer, LMarker,LPopup,LCircleMarker } from 'vue2-leaflet';
import VGeosearch from 'vue2-leaflet-geosearch';
import { OpenStreetMapProvider } from 'leaflet-geosearch';

import {
    mapGetters
} from 'vuex'

export default {
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    data(){
        return{
        valid:true,
        sede: [],
        idcompany: '',
        informationvenuescomponent: false,
        autoUpdate: true,
        friends: ['Sandra Adams', 'Britta Holt'],
        isUpdating: false,
        isEdit: true,
        isaddresscorrect: false,
        islocationcorrect: false,

        name: 'Midnight Crew',
        search: '',
        managers: [],
        managersinserted: [],
        markers: [],
        disabledinputaddress: true,
        modaldelete: false,
        locationvenues: [],
        title: 'The summer breeze',
        rules: {
            required: value => !!value || 'Requerido.',
        },
            ModalCreactionVenues: false,
            imageUrl: '',
            imageFile: '',
            imageName: '',
            managertext: '',
            createvenues: new Venues(),
            geosearchOptions: { // Important part Here
                provider: new OpenStreetMapProvider(),
            },
            latitude:-12.0454324, longitude:-75.2376588,
            newMaker:[],
            locationFirst:false,
            selected:{
                selected:false,
                latitude:null,
                longitude:null,
            },
            
        }
    },
    
    sockets:{
        remove (item) {
        const index = this.friends.indexOf(item.name)
        if (index >= 0) this.friends.splice(index, 1)
      },
        
        message(data){
            console.log(data,' :client');
        },
        location(data){
            data.forEach(element=>{
                this.newMaker.push(element);
            })
            
        }
    },
    created(){

    },
    mounted(){
        this.getidentity()
        this.checked()
        this.idcompany=this.$route.params.empresa;
        EventBus.$on('seeinformationvenues',(data)=>{
            this.ModalCreactionVenues = false
            this.sede = [data]
            //console.log(this.sede[0])
            this.locationvenues = this.sede[0].location
            //console.log(this.locationvenues)
            EventBus.$emit('closeeditcompany')
            this.showcomponentedit();

        })
        EventBus.$on('openModalCreactionVenues', () => {
            this.openModalCreactionVenues()
            EventBus.$emit('closecomponentvenues')
            document.getElementsByClassName('glass')[0].setAttribute("placeholder","Escriba su Dirección")
            this.disabledinputaddress = true
            this.isaddresscorrect = false
            EventBus.$emit('closeeditcompany')
            //console.log(document.getElementsByClassName('glass'))
        })
        EventBus.$on('openchat', () =>{
            this.informationvenuescomponent = false
            this.ModalCreactionVenues = false
        })
        EventBus.$on('editdatacompany',()=>{
            this.disabledinputaddress = true
            this.isaddresscorrect = false
            this.informationvenuescomponent = false
            this.ModalCreactionVenues = false
            this.gobackseevenues()
        })
    },
    components:{
        LMap, LTileLayer, LMarker,LPopup,LCircleMarker, VGeosearch
    },
    watch:{
        search:function(value){
            let search = value
            this.axios.get(`/company/showusermanager/${search}`)
            .then((res)=>{
                if(this.managers.length <= 0){
                    this.managers = res.data.users
                    //console.log(res.data.users)
                }else{
                    let managerarrangementisgreater20 = this.managers.length > 20
                    if(!managerarrangementisgreater20){
                        let i
                        for (i=0;i<res.data.users.length;i++) {
                        this.managers.push(res.data.users[i])
                        }
                    }
                    //this.managers.push([res.data.users])
                    //console.log(res.data.users)
                }
                
            })
        },
        isUpdating (val) {
            if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
            }
        }
    },
    methods: {
        gobackseevenues(){
            this.isaddresscorrect = false
            document.getElementsByClassName('leaflet-control-geosearch')[0].style.visibility = 'active'
            this.markers = []
        },
        functionaddressiscorrect(){
            if(this.createvenues.address === ''){
                alertify.error('Escriba su Dirección referencial')
            }else{
                this.isaddresscorrect = true
                document.getElementsByClassName('glass')[0].value = ''
                document.getElementsByClassName('leaflet-control-geosearch')[0].style.visibility = 'hidden'
            }
        },
        removeMarker(locationvenues) {
            this.markers.splice(locationvenues, 1);
        },
        addMarker(event) {
            //console.log(event)
            if(this.isaddresscorrect === true){
                this.markers = [event.latlng]
                //console.log(this.markers)
                this.createvenues.location.latitude = this.markers[0].lat
                this.createvenues.location.longitude= this.markers[0].lng
            }
            
            //console.log(this.createvenues)
            //this.markers.push(event.latlng);
        },
        showcomponentedit(){
            this.isEdit = true
            this.ModalCreactionVenues = true
            this.informationvenuescomponent = false
            //this.createvenues = new Venues()
            this.createvenues.name =  this.sede[0].name
            this.createvenues.address =  this.sede[0].address
            //console.log(this.sede[0].isvenueprincipal)
            this.latitude = this.locationvenues[0]
            this.longitude = this.locationvenues[1]
            this.createvenues.location.latitude = this.locationvenues[0]
            this.createvenues.location.longitude= this.locationvenues[1]
            //console.log(this.createvenues)
            //document.getElementsByClassName('glass')[1].value = this.createvenues.address
        },
        deletecompanyvenues(){
            let idofficecompany = this.sede[0]._id
            this.axios.delete(`company/deleteofficecompany/${this.identity._id}/${this.token}/${this.idcompany}/${idofficecompany}`)
            .then(()=>{
                this.modaldelete = false
               this.opencomponentvenues()
            })
        },
        opencomponentvenues(){
            this.ModalCreactionVenues = false
            this.informationvenuescomponent = false
            EventBus.$emit('opencomponentvenues')
        },
        createcompanyvenues(){
            this.idcompany=this.$route.params.empresa;
            if (this.$refs.form.validate()) {
                if(this.isEdit === false){
                    if(this.createvenues.address === ''){
                        alertify.error('Escriba la dirección de su lavanderia')
                    }else{
                        this.snackbar = true
                        //this.insertaddress()
                        //this.checkedLocation()
                        ///company/createofficecompany/:id/:token/:idcompany
                        //console.log(this.createvenues)
                        this.axios.post(`company/createofficecompany/${this.identity._id}/${this.token}/${this.idcompany}`, this.createvenues)
                        .then(()=>{
                            //console.log(res)
                            alertify.success('Sede Agregada')
                            this.managersinserted = []
                            this.createvenues = new Venues()
                            this.opencomponentvenues()
                        })
                        .catch((err)=>{
                            let msg = err.response.data.message
                            if(msg === 'Solo puedes crear hasta 200 sedes'){
                                alertify.error(msg)
                            }
                        })
                    }
                }else{
                    let idofficecompany = this.sede[0]._id
                    this.snackbar = true
                    this.axios.put(`company/editofficecompany/${this.identity._id}/${this.token}/${this.idcompany}/${idofficecompany}`, this.createvenues)
                    .then(()=>{
                        //console.log(res)
                        alertify.success('Esta actualizado los datos de la sede ' + this.sede[0].name)
                        this.managersinserted = []
                        this.createvenues = new Venues()
                        //this.opencomponentvenues()
                        window.location = `${env.host}empresa/created/${this.idcompany}`
                    })

                }
                
            }
        },
        writeinputaddress(){
            if(this.createvenues.address == ''){
                this.disabledinputaddress = true
            }else{
                this.disabledinputaddress = false
            }
        },
        getusersmanager(e){
            console.log(e)
        },
        insertaddress(){
        
            let i
            for(i in this.managersinserted){
                this.createvenues.managers.push({
                    _iduser:this.managersinserted[i],
                    rol: 'admin',
                    status: true,
                })
            }
            //console.log(this.createvenues.managers)
            //this.managersinserted = []
            
        },
        writeaddress(){
            if(this.isaddresscorrect === false){
                document.getElementsByClassName('glass')[0].setAttribute("placeholder","Escriba su Dirección")
                if(document.getElementsByClassName('glass')[0].value !== '') {
                    this.createvenues.address = document.getElementsByClassName('glass')[0].value
                    this.disabledinputaddress = false
                    let provider = this.geosearchOptions.provider
                    var query_promise = provider.search({
                        query: this.createvenues.address
                    })

                        query_promise.then(value => {
                            //console.log(value)
                            this.createvenues.location.latitude = value[0].y
                            this.createvenues.location.longitude= value[0].x
                            this.latitude = value[0].y
                            this.longitude = value[0].x
                            /*
                            let i
                            for (i = 0; i < value.length; i++) {
                                // Success!
                                var x_coor = value[i].x;
                                var y_coor = value[i].y;
                                var label = value[i].label;
                                var marker = L.marker([y_coor, x_coor]).addTo(map) // CAREFULL!!! The first position corresponds to the lat (y) and the second to the lon (x)
                                marker.bindPopup("<b>Found location</b><br>" + label).openPopup(); // note the "openPopup()" method. It only works on the marker
                            };
                            */
                            });
                }else{
                    this.disabledinputaddress = true
                    this.createvenues.address = ''
                }
            
            }
            
            
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
    
        },
        openModalCreactionVenues(){
            this.isEdit = false
            this.createvenues = new Venues()
            this.sede = []
            this.locationvenues = []
            this.latitude = -12.0454324
            this.longitude = -75.2376588
            this.ModalCreactionVenues = true
        },

        
        checkedLocation:function(){
            console.log('log');
            this.locationFirst=true;
            //var i=1;
            //var me =this;
        },
        recuvaLocation:function(){
            if(this.isEdit === false){
                if(navigator.geolocation){
                    navigator.geolocation.watchPosition(this.successPosition,this.failurePosition,{
                        enableHighAccuracy:false,
                        timeout:1000,
                        maximumAge:4000
                    })
                }
                else{
                    alert('not supported')
                }
            }
        },
        successPosition:function(position){
            console.log('prueba',position);
            this.latitude=position.coords.latitude;
            this.longitude=position.coords.longitude;
            //this.sendLocation();
        },
        failurePosition:function(err){
            console.log('Error',err);
        },
        checked:function(){
            //this.sendLocation();
            this.recuvaLocation();
        },

        openmodalservicesbyvenues(){
            let datavenues = {
                id: this.sede[0]._id,
                name: this.sede[0].name
            }
            EventBus.$emit('openmodalservicesbyvenues', datavenues)
        }
        
        
    }
        
}

</script>
<style>
    .leaflet-maps {
        position: relative;
        padding-bottom: 75%; 
        height: 0;
        overflow: hidden;
    }
    
</style>
